(() => {
  const NEEDLE = ';;;';
  const REQUEST_PAGE_SIZE = 250;

  function getSectionRoot() {
    return document.querySelector('[data-wd-availability-sort]');
  }

  function buildViewUrl(collectionUrl, view, page, searchParams) {
    const url = new URL(collectionUrl, window.location.origin);
    searchParams.forEach((value, key) => {
      if (key === 'page' || key === 'section_id' || key === 'view') return;
      url.searchParams.append(key, value);
    });
    url.searchParams.set('view', view);
    url.searchParams.set('page', String(page));
    return url.toString();
  }

  function splitCards(html) {
    return html
      .split(NEEDLE)
      .map((chunk) => chunk.trim())
      .filter(Boolean);
  }

  async function fetchViewCards(collectionUrl, view, totalProducts, searchParams) {
    const pageCount = Math.max(1, Math.ceil(totalProducts / REQUEST_PAGE_SIZE));
    const pageNumbers = Array.from({ length: pageCount }, (_, index) => index + 1);

    const responses = await Promise.all(
      pageNumbers.map(async (page) => {
        const response = await fetch(buildViewUrl(collectionUrl, view, page, searchParams), {
          credentials: 'same-origin'
        });
        if (!response.ok) return '';
        return response.text();
      })
    );

    return responses.flatMap(splitCards);
  }

  function isInStockOnlyFilter(searchParams) {
    return (
      searchParams.get('filter.v.availability') === '1' ||
      searchParams.get('filter.p.m.custom.stock_status') === '1'
    );
  }

  async function sortAndRender(sectionRoot) {
    if (!sectionRoot || sectionRoot.dataset.wdAvailabilitySortLoading === 'true') return;

    const productList = sectionRoot.querySelector('[data-wd-availability-product-list]');
    if (!productList) return;

    const collectionUrl = sectionRoot.dataset.collectionUrl;
    const productsPerPage = Number(sectionRoot.dataset.productsPerPage || 48);
    const productsCount = Number(sectionRoot.dataset.productsCount || 0);
    if (!collectionUrl || productsCount === 0) return;

    sectionRoot.dataset.wdAvailabilitySortLoading = 'true';
    productList.setAttribute('aria-busy', 'true');

    try {
      const searchParams = new URLSearchParams(window.location.search);
      const currentPage = Math.max(1, Number(searchParams.get('page') || 1));
      const inStockOnly = isInStockOnlyFilter(searchParams);

      const [availableCards, unavailableCards] = await Promise.all([
        fetchViewCards(collectionUrl, 'wd-available', productsCount, searchParams),
        inStockOnly
          ? Promise.resolve([])
          : fetchViewCards(collectionUrl, 'wd-unavailable', productsCount, searchParams)
      ]);
      const orderedCards = availableCards.concat(unavailableCards);
      if (orderedCards.length === 0) return;

      const totalPages = Math.max(1, Math.ceil(orderedCards.length / productsPerPage));


      if (currentPage > totalPages) {
        productList.innerHTML = '';
        sectionRoot.querySelector('.pagination')?.remove();
        return;
      }

      const start = (currentPage - 1) * productsPerPage;
      const pageCards = orderedCards.slice(start, start + productsPerPage);

      productList.innerHTML = pageCards.join('');

      sectionRoot.querySelectorAll('.pagination a').forEach((link) => {
        const page = Number(new URL(link.href).searchParams.get('page') || 1);
        if (page > totalPages) (link.closest('li') || link).remove();
      });
    } catch (error) {
      console.error('[wd-collection-availability-sort]', error);
    } finally {
      productList.removeAttribute('aria-busy');
      sectionRoot.dataset.wdAvailabilitySortLoading = 'false';
    }
  }

  function init() {
    const sectionRoot = getSectionRoot();
    if (!sectionRoot) return;
    sortAndRender(sectionRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('collection:update', init);
})();
